import { useToast } from "@chakra-ui/react";
import { performFileExport } from "../utils/exporter";

export function useFileExport() {
  const toast = useToast();

  const exportFile = async ({
    format,
    data,
    columns,
    tableName,
    exportFileName,
    filtersValues,
    loading = false,
    discardedFields = [],
    sortRules = [], // NEW: Accept sort rules
    shouldSort = true, // NEW: Option to disable sorting
  }) => {
    try {
      if (!data || !data.length || loading) {
        toast({
          title: "No data to download",
          status: "error",
          duration: 4000,
          isClosable: true,
          position: "top-right",
        });
        return;
      }

      await performFileExport({
        format,
        data,
        columns,
        exportFileName,
        filtersValues,
        discardedFields,
        shouldSort,
        sortRules,
        onSuccess: () => {
          toast({
            title: `${tableName} exported as ${format.toUpperCase()}`,
            status: "success",
            duration: 4000,
            isClosable: true,
            position: "top-right",
          });
        },
      });
    } catch (error) {
      console.error(error);
      toast({
        title: "Export failed",
        description: "Something went wrong during file export.",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "top-right",
      });
    }
  };

  return { exportFile };
}
